import reportIcon from "components/icons/DangerTriangle.svg";
import hideIcon from "components/icons/eye.svg";
// import addIcon from "components/icons/FolderAdd2.svg";
import shareIcon from "components/icons/share-red.svg";
import collectionIcon from "components/icons/bookmark.svg";
import manageIcon from "components/icons/manage_icon.svg";
import GearIcon from "components/icons/gear.svg";

export const getMoreMenuData = ({ actions, currentUser, gif }: any) => {
  const {
    onHide,
    onManageClick,
    toggleCollection,
    toggleReport,
    toggleShareMenu,
    toggleChangeNichesDialog,
  } = actions;

  const isAuth = !!currentUser;
  const isCM = !!currentUser?.isContentManager();
  const isThisUserGif = gif.userName === currentUser?.username;

  return [
    {
      groupName: null,
      groupMobileName: null,
      items: [
        {
          icon: shareIcon,
          title: "Share",
          onClick: toggleShareMenu
        },
        // ...(isAuth ? [{
        //   icon: addIcon,
        //   title: "Add to a niche",
        //   onClick: toggleNiche
        // }] : []),
        ...(isAuth ? [{
          icon: collectionIcon,
          title: "Add to a collection",
          onClick: toggleCollection
        }] : []),
        {
          icon: reportIcon,
          title: "Report",
          onClick: toggleReport
        },
        ...(isCM ? [{
          icon: hideIcon,
          title: "Hide",
          onClick: onHide
        }] : []),
        ...(isCM ? [{
          icon: GearIcon,
          title: "Change niches",
          onClick: toggleChangeNichesDialog,
        }] : []),
        ...(isThisUserGif ? [{
          icon: manageIcon,
          title: "Manage",
          onClick: onManageClick,
        }] : []),
      ]
    }
  ];
};
